/** Query keys for the case events table. */
export const caseEventKeys = {
  all: ["case-events"],
  lists: () => [...caseEventKeys.all, "list"],
  list: ({ caseId = null } = {}) => [...caseEventKeys.lists(), { caseId }],
};
